export default __webpack_public_path__ + "static/media/ic-shareholders.9a896953.svg";